import React from "react";
import PropTypes from "prop-types";
import { Wallet } from "phosphor-react";
import CardDetails from "../CardDetails";
import "./index.scss";

const PaymentMethod = ({
  payments,
  cardErrorMessage,
  cardDetails,
  validateCardOnchange,
  handleChangeCardName,
  validateInput,
  paymentMethod,
  setPaymentMethod,
}) => {
  return (
    <div className="payment-method">
      <h2>Payment Method</h2>
      <div className="icon-wrapper">
        <Wallet size={32} color="#070C1E" />
      </div>
      <div className="inline">
        <button
          type="button"
          className={`payment-options ${
            paymentMethod === "stripe" ? "-selected" : ""
          }`}
          onClick={(e) => setPaymentMethod(e, "stripe")}
          aria-hidden
        >
          <p className="label">Card</p>
          <p className="description" />
        </button>
        <button
          type="button"
          className={`payment-options ${
            paymentMethod === "invoice" ? "-selected" : ""
          }`}
          onClick={(e) => setPaymentMethod(e, "invoice")}
          aria-hidden
          disabled={!payments.includes("invoice")}
        >
          <p className="label">Invoice</p>

          {!payments.includes("invoice") ? (
            <p className="description">
              If you want this payment option, please{" "}
              <a className="link" href="mailto:support@datafarming.com.au">
                {" "}
                contact{" "}
              </a>{" "}
              us.
            </p>
          ) : (
            ""
          )}
        </button>
      </div>
      {paymentMethod === "stripe" && (
        <CardDetails
          cardErrorMessage={cardErrorMessage}
          cardDetails={cardDetails}
          validateCardOnchange={validateCardOnchange}
          handleChangeCardName={handleChangeCardName}
          validateInput={validateInput}
        />
      )}
    </div>
  );
};

PaymentMethod.defaultProps = {
  payments: [],
  cardErrorMessage: {},
  cardDetails: {},
  validateCardOnchange: () => {},
  handleChangeCardName: () => {},
  validateInput: () => {},
  paymentMethod: "",
  setPaymentMethod: () => {},
};
PaymentMethod.propTypes = {
  payments: PropTypes.shape({
    includes: PropTypes.func,
  }),
  cardErrorMessage: PropTypes.shape({
    error: PropTypes.string,
  }),
  cardDetails: PropTypes.shape({
    error: PropTypes.string,
  }),
  handleChangeCardName: PropTypes.func,
  validateCardOnchange: PropTypes.func,
  validateInput: PropTypes.func,
  paymentMethod: PropTypes.string,
  setPaymentMethod: PropTypes.func,
};

export default PaymentMethod;
